import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { act } from "react";

export interface NoteState {
  notes: [any];
}

const initialState: NoteState = {
  notes: <any>[],
}

export const noteSlice = createSlice({
  name: "note",
  initialState,
  reducers: {
    setNotes: (state, action: PayloadAction<any>) => {
      state.notes = action.payload;
    },
  }
});

export const {
  setNotes,
} = noteSlice.actions;

export default noteSlice.reducer;
